import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import NewCustomer from "@/pages/NewCustomer";
import CustomerDetail from "@/pages/CustomerDetail";
import Tickets from "@/pages/Tickets";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Sign from "@/pages/Sign";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sign/:token" element={<Sign />} />
          <Route path="/" element={<Shell><Dashboard /></Shell>} />
          <Route path="/customers" element={<Shell><Customers /></Shell>} />
          <Route
            path="/customers/new"
            element={
              <ProtectedRoute roles={["admin", "sales"]}>
                <Layout><NewCustomer /></Layout>
              </ProtectedRoute>
            }
          />
          <Route path="/customers/:id" element={<Shell><CustomerDetail /></Shell>} />
          <Route path="/tickets" element={<Shell><Tickets /></Shell>} />
          <Route
            path="/settings"
            element={
              <ProtectedRoute roles={["admin"]}>
                <Layout><Settings /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute roles={["admin"]}>
                <Layout><Users /></Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
